// extracted by mini-css-extract-plugin
export default {"inner-wrap":"OptionsPanel_inner-wrap__GNG7i","code":"OptionsPanel_code__XyCZa","slowRiseAndFall":"OptionsPanel_slowRiseAndFall__ZShub"};